import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/** Maps `/ate+/details-tabs?projectId=...` to `/ate+/project/:projectId`. */
const ATEDetailsTabsRedirect = () => {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId')?.trim();
  if (!projectId) {
    return <Navigate to="/ate+/all-projects" replace />;
  }

  const nav = searchParams.get('nav');
  const target = new URLSearchParams();
  if (nav) {
    target.set('nav', nav);
  }
  const query = target.toString();
  return <Navigate to={`/ate+/project/${encodeURIComponent(projectId)}${query ? `?${query}` : ''}`} replace />;
};

/** Redirects legacy `/ate+/project-details/:projectId` to `/ate+/project/:projectId`. */
export const ATEPlusProjectLegacyRedirect = () => {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) {
    return <Navigate to="/ate+/all-projects" replace />;
  }
  return <Navigate to={`/ate+/project/${encodeURIComponent(projectId)}`} replace />;
};

export default ATEDetailsTabsRedirect;
